import React from 'react';

export function FormError(props) {
  //Element with html in error message should have hastHtml attribute set to True
  var hasHtml = props.hasHtml;
    if(hasHtml){
      return (
      //To Render message with html embedded in it.
      <span className='formErrors has-error help-block' id={props.id}>
          <p dangerouslySetInnerHTML={createMarkup(props.errorMessage)}/>
      </span>
      );
    }
    //To Render message with plain text
    return (
      <span className='formErrors has-error help-block' id={props.id}>
          <p> {props.errorMessage} </p>
      </span>
    );
}

function createMarkup(markup) {
  return {__html: markup};
}



// WEBPACK FOOTER //
// ./src/FormError.js